import angular from 'angular';

class CompanyAutocompleteFilterController {
    /*@ngInject*/
    constructor(CompanyService, logger, $filter) {
        this.$filter = $filter;
        this.CompanyService = CompanyService;
        this.logger = logger;
    }

    $onInit() {}

    $onChanges(changesObj) {
        let vm = this;
        if (changesObj.principalId) {
            vm.companySelected = null;
            vm.updateCompaniesList();
        }
    }

    /**
     * Met à jour la liste des sociétés disponible dans l'autocomplete.
     */
    updateCompaniesList(value) {
        let vm = this;

        if (value && value.length >= 3) {
            return this.CompanyService.searchByCriterias({
                principalId: this.principalId,
                companyName: value
            }).$promise.then(
                function(companies) {
                    return vm.$filter('orderBy')(companies, 'companyName');
                },
                function() {
                    this.logger.error('principal.company.search_error');
                }
            );
        } else {
            vm.companies = null;
        }
    }
}

angular.module('app.core').component('kissCompanyAutocompleteFilter', {
    templateUrl: require('./company-autocomplete-filter.html'),
    controller: CompanyAutocompleteFilterController,
    bindings: {
        principalId: '<', // Liste des valeurs possible de sociétés
        companySelected: '=' // Société sélectionnée
    }
});
